/*
MIT LICENSE
Copyright (c) 2020-present Alibaba Cloud Design
Copied from 'antd/components/transfer/ListBody.tsx'.
Copyright (c) 2015-present Ant UED, https://xtech.antfin.com/

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */
import React from 'react';
import classNames from 'classnames';
import { Pagination } from '../pagination';
import ListItem from './ListItem';
import { OmitProp, OmitProps } from 'antd/lib/transfer/ListBody';
export { OmitProps };
function parsePagination(pagination) {
    if (!pagination) {
        return null;
    }
    const defaultPagination = {
        pageSize: 10
    };
    if (typeof pagination === 'object') {
        return {
            ...defaultPagination,
            ...pagination
        };
    }
    return defaultPagination;
}
class ListBody extends React.Component {
    state = {
        current: 1
    };
    static getDerivedStateFromProps({ filteredRenderItems, pagination }, { current }) {
        const mergedPagination = parsePagination(pagination);
        if (mergedPagination) {
            // Calculate the page number
            const maxPageCount = Math.ceil(filteredRenderItems.length / mergedPagination.pageSize);
            if (current > maxPageCount) {
                return { current: maxPageCount };
            }
        }
        return null;
    }
    onItemSelect = (item) => {
        const { onItemSelect, selectedKeys } = this.props;
        const checked = selectedKeys.indexOf(item.key) >= 0;
        onItemSelect(item.key, !checked);
    };
    onItemRemove = (item) => {
        const { onItemRemove } = this.props;
        onItemRemove?.([item.key]);
    };
    onPageChange = (current) => {
        this.setState({ current });
    };
    getItems = () => {
        const { current } = this.state;
        const { pagination, filteredRenderItems } = this.props;
        const mergedPagination = parsePagination(pagination);
        let displayItems = filteredRenderItems;
        if (mergedPagination) {
            displayItems = filteredRenderItems.slice((current - 1) * mergedPagination.pageSize, current * mergedPagination.pageSize);
        }
        return displayItems;
    };
    render() {
        const { current } = this.state;
        const { prefixCls, onScroll, filteredRenderItems, selectedKeys, disabled: globalDisabled, showRemove, pagination } = this.props;
        const mergedPagination = parsePagination(pagination);
        let paginationNode = null;
        if (mergedPagination) {
            paginationNode = (React.createElement(Pagination, { simple: true, size: 'small', disabled: globalDisabled, className: `${prefixCls}-pagination`, total: filteredRenderItems.length, pageSize: mergedPagination.pageSize, current: current, onChange: this.onPageChange }));
        }
        const listBodyFooter = (React.createElement("div", { className: `${prefixCls}-footer` },
            this.props.footerDom,
            paginationNode));
        return (React.createElement(React.Fragment, null,
            React.createElement("ul", { className: classNames(`${prefixCls}-content`, {
                    [`${prefixCls}-content-show-remove`]: showRemove
                }), onScroll: onScroll }, this.getItems().map(({ renderedEl, renderedText, item }) => {
                const { disabled } = item;
                const checked = selectedKeys.indexOf(item.key) >= 0;
                return (React.createElement(ListItem, { disabled: globalDisabled || disabled, key: item.key, item: item, renderedText: renderedText, renderedEl: renderedEl, checked: checked, prefixCls: prefixCls, 
                    // @ts-ignore
                    onClick: this.onItemSelect, 
                    // @ts-ignore
                    onRemove: this.onItemRemove, showRemove: showRemove }));
            })),
            listBodyFooter));
    }
}
export default ListBody;
